import React, { useState, useEffect } from 'react';
import { Zap } from 'lucide-react'; // Asegúrate de tener lucide-react instalado

// --- COMPONENTE LOADING OVERLAY ---
const LoadingOverlay = () => {
  const [loadingText, setLoadingText] = useState("Iniciando inscripción...");
  const [isVisible, setIsVisible] = useState(false);

  // Efecto de aparición suave al montar
  useEffect(() => {
    // Pequeño delay para que la transición CSS funcione si se monta condicionalmente
    const timer = setTimeout(() => setIsVisible(true), 10);
    return () => clearTimeout(timer);
  }, []);

  // Lógica de rotación de mensajes
  useEffect(() => {
    const messages = [
      "Conectando con el servidor seguro...",
      "Verificando disponibilidad de cupos...",
      "Registrando tus datos en el sistema...",
      "Generando tu acceso al curso...",
      "¡Ya casi estamos listos!"
    ];
    
    let currentIndex = 0;
    const intervalId = setInterval(() => {
      currentIndex = (currentIndex + 1) % messages.length;
      setLoadingText(messages[currentIndex]);
    }, 1500); // Cambia el mensaje cada 1.5 segundos

    return () => clearInterval(intervalId);
  }, []);

  return (
    <>
      <div className={`fixed inset-0 z-[60] flex flex-col items-center justify-center bg-white/95 backdrop-blur-md rounded-xl transition-all duration-500 ease-out ${isVisible ? 'opacity-100' : 'opacity-0'}`}>
        
        {/* Spinner Central */}
        <div className="relative mb-8">
          {/* Anillo base gris estático */}
          <div className="w-24 h-24 border-[6px] border-gray-100 rounded-full"></div>
          
          {/* Anillo de carga giratorio (Lime Green) */}
          <div className="w-24 h-24 border-[6px] border-[#ccff00] rounded-full border-t-transparent animate-spin absolute inset-0 shadow-[0_0_15px_rgba(204,255,0,0.4)]"></div>
          
          {/* Icono central pulsante */}
          <div className="absolute inset-0 flex items-center justify-center">
            <Zap className="w-8 h-8 text-[#8cb300] animate-pulse fill-current" />
          </div>
        </div>

        {/* Textos Dinámicos */}
        <h3 className="text-xl font-black text-gray-800 mb-2 tracking-tight animate-pulse text-center px-4">
          {loadingText}
        </h3>
        
        <p className="text-sm text-gray-500 font-medium text-center max-w-[200px] leading-relaxed">
          Por favor, no cierres ni recargues esta ventana.
        </p>

        {/* Barra de progreso decorativa */}
        <div className="w-48 h-1.5 bg-gray-100 rounded-full mt-6 overflow-hidden relative">
          <div className="absolute top-0 left-0 h-full w-full bg-gradient-to-r from-[#ccff00] to-green-400 rounded-full loading-bar-anim"></div>
        </div>

      </div>

      {/* Estilos encapsulados para la animación de la barra */}
      <style>{`
        @keyframes indeterminate-slide {
          0% { transform: translateX(-100%); }
          100% { transform: translateX(100%); }
        }
        .loading-bar-anim {
          animation: indeterminate-slide 1.5s infinite linear;
        }
      `}</style>
    </>
  );
};
// --- FIN DEL COMPONENTE LOADING ---

export default LoadingOverlay;